import React, {useState} from "react";
import { Link } from 'react-router-dom';
//--- CONTEXT API -----------
import AuthService from "../../services/auth.service";
import { useStore, useDispatch } from "store/StoreProvider";
import { useNavigate } from "react-router-dom";

import{
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,DropdownMenu,
  DropdownItem,
  NavbarText
} from 'reactstrap';

const Navbar2 =(props) =>{
  const navigate = useNavigate();
  //---------------- CONTEXT API ------------------
  const store = useStore();
  const {user, products} = store;

  const [isOpen, setIsOpen] = useState(false);
  const toggle= () =>setIsOpen(!isOpen);

  //--------------------------------------------
  const menuSideToogle_click=()=>{
    //--- enviamos el clic afuera
    props.btnMenuClick();
  }
  //--------------------------------
  const logout=(e)=>{
    e.preventDefault();
    
    //console.log("aqui estoy");
    AuthService.logout();
    navigate("/login");
    //let history = useHistory();
    //history.push("/login");
  }
  //---------------------------------
  return (
    <div >
      <Navbar color=""  expand="md" className="navbar_j  navbar-light">
      <button type="button" id="sidebarCollapse" className="btn btn-info"
              onClick={(e)=> menuSideToogle_click() }>
          <i className="fa fa-align-left"></i>
          <span>Menu</span>
      </button>
      {/*<NavbarBrand href="/">reactstrap</NavbarBrand>*/}
      <NavbarToggler  color="dark" 
                      onClick={toggle} 
                      className="btn btn-seccondary"/>
     
      <Collapse isOpen={isOpen} navbar>
        {/* a la derecha alineado */}
        <Nav className="ms-auto" navbar>
          {/*<NavItem>
            <NavLink href="/components/">Components</NavLink>
          </NavItem>*/}

          <UncontrolledDropdown nav inNavbar >
            <DropdownToggle nav caret> 
              {user.username } 
            </DropdownToggle>
            <DropdownMenu>
              {/* 
              <DropdownItem to="/mi_perfil_e">
                  Mi perfil                
              </DropdownItem>
              <DropdownItem>
                Configuracion
              </DropdownItem>
              */}
              <DropdownItem divider/>
              <DropdownItem onClick={logout}>
                Cerrar sesion
              </DropdownItem>

            </DropdownMenu>
          </UncontrolledDropdown>

        </Nav>
        
      </Collapse>
      
      </Navbar>
    </div>
  );
}

export default Navbar2;